module.exports = __webpack_public_path__ + "img/sv.46858d6.svg";